import { usePrefetchFeatureFlags } from "@portal/api/feature-flags";
import { AppLoading } from "@portal/views/shared/AppLoading";
import { ReactNode } from "react";

type AgentPrefetchProviderProps = {
	children: ReactNode;
};

export const AgentPrefetchProvider = ({ children }: AgentPrefetchProviderProps) => {
	const { isLoading: isFeatureFlagsLoading } = usePrefetchFeatureFlags();

	if (!isFeatureFlagsLoading) {
		return children;
	} else {
		return <AppLoading key="1" />;
	}
};
